import { DeviceStatusPipe } from './device-status.pipe';
import { NgModule } from '@angular/core';

@NgModule({
    exports: [DeviceStatusPipe],
    declarations: [DeviceStatusPipe]
})
export class DeviceStatusPipeModule { }
